module.exports = __webpack_public_path__ + "static/media/hamburguer.93d533db.svg";